import { useContext } from 'react';

import { ChangeDetectorContext } from '../../../../../shared/components/change-detector-context/ChangeDetectorContext';

export const useChangeDetectorContextState = () => {
  const cdContext = useContext(ChangeDetectorContext);

  return (isOpen: boolean) => {
    cdContext?.setIsChanged(isOpen);
  };
};
